import { onDomReady } from "../services/on-dom-ready";
import ModalBlocked from "../components/modal/modal-blocked";

const showVkError = () => {
    onDomReady.then(() => {
        const element = document.getElementById("vk-error");

        if (element) {
            const popup = ModalBlocked.get(element);

            popup.open();
        }
    });
};

export { showVkError };
